var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    transform: "translate(-1434.889 -970.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(1009.889 138)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 42,
    height: 41,
    transform: "translate(425 832.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "trash",
    transform: "translate(426.509 833.509)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 38,
    height: 38,
    transform: "translate(0.49 -0.009)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_18",
    "data-name": "Line 18",
    d: "M20.112-5.556H-6.778A1.222,1.222,0,0,1-8-6.778,1.222,1.222,0,0,1-6.778-8H20.112a1.222,1.222,0,0,1,1.222,1.222A1.222,1.222,0,0,1,20.112-5.556Z",
    transform: "translate(12.862 14.73)",
    fill: "#242323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_19",
    "data-name": "Line 19",
    d: "M-6.778,4.222A1.222,1.222,0,0,1-8,3V-6.778A1.222,1.222,0,0,1-6.778-8,1.222,1.222,0,0,1-5.556-6.778V3A1.222,1.222,0,0,1-6.778,4.222Z",
    transform: "translate(22.64 22.064)",
    fill: "#242323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_20",
    "data-name": "Line 20",
    d: "M-6.778,4.222A1.222,1.222,0,0,1-8,3V-6.778A1.222,1.222,0,0,1-6.778-8,1.222,1.222,0,0,1-5.556-6.778V3A1.222,1.222,0,0,1-6.778,4.222Z",
    transform: "translate(29.973 22.064)",
    fill: "#242323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M70,74.889H50.444A2.447,2.447,0,0,1,48,72.445V49.222a1.222,1.222,0,1,1,2.444,0V72.445H70V49.222a1.222,1.222,0,0,1,2.444,0V72.445A2.447,2.447,0,0,1,70,74.889Z",
    transform: "translate(-40.694 -41.27)",
    fill: "#242323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M93.445,23.333a1.222,1.222,0,0,1-1.222-1.222V19.667A1.224,1.224,0,0,0,91,18.444H83.667a1.224,1.224,0,0,0-1.222,1.222v2.444a1.222,1.222,0,0,1-2.444,0V19.667A3.671,3.671,0,0,1,83.667,16H91a3.671,3.671,0,0,1,3.667,3.667v2.444A1.222,1.222,0,0,1,93.445,23.333Z",
    transform: "translate(-67.805 -14.158)",
    fill: "#242323"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.4080a08682005f6c8a385673889413f0.svg";
export { ForwardRef as ReactComponent };